import { useContext } from 'react';
import {
  UserBrokeredValue,
  UserContext
} from '@/components/context/UserContext/UserContext';
import { User } from '@/types/User';

export const useLoggedInUser = (): User | undefined => {
  const contextValue = useContext(UserContext);

  return contextValue.value;
};

export const useUser = (): UserBrokeredValue => {
  const contextValue = useContext(UserContext);
  return contextValue;
};
